export default __webpack_public_path__ + "312c311438b0b8254a82f7aeda0301d5.svg";